var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"az_panel clearfix"},[_c('div',{staticClass:"az-lft lft-block"},[_vm._t("lft")],2),_c('div',{staticClass:"az-rt rt-block"},[_vm._t("rt")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }